export const domain = () => window.location.hostname.split('.').slice(-2).join('.');
